import {
  getMemberById,
  clearGetMemberById,
  updateNonMember,
} from "../../../Redux/Members/MembersActions";
import { getAllBuildings } from "../../../Redux/Buildings/BuildingActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { Link, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import React, { useEffect, useState } from "react";
import styles from "./EditNonMember.module.scss";
import validator from "../../../Util/validator";

function EditNonMember() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { buildings } = useSelector((state: RootState) => state.buildings);

  const { memberById, updateNonMemberLoading, memberByIdLoading } = useSelector(
    (state: RootState) => state.members,
  );

  const [buildingId, setBuildingId] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [idNumber, setIdNumber] = useState<string>("");
  const [isActive, setIsActive] = useState<string>("true");
  const [errors, setErrors] = useState<{
    buildingId: string;
    firstName: string;
    lastName: string;
    email: string;
    idNumber: string;
    isActive: string;
  }>({
    buildingId: "",
    firstName: "",
    lastName: "",
    email: "",
    idNumber: "",
    isActive: "",
  });

  const updateNonMemberHandler = () => {
    const { errors: fieldErrors, isValid } = validator([
      {
        key: "buildingId",
        type: "text",
        value: buildingId,
      },
      {
        key: "firstName",
        type: "text",
        value: firstName,
      },
      {
        key: "lastName",
        type: "text",
        value: lastName,
      },
      {
        key: "email",
        type: "email",
        value: email,
      },
      {
        key: "idNumber",
        type: "text",
        value: idNumber,
      },
      {
        key: "isActive",
        type: "text",
        value: isActive,
      },
    ]);
    setErrors({ ...errors, ...fieldErrors });

    if (isValid) {
      if (!updateNonMemberLoading && id) {
        const successHandler = () => {
          navigate("/admin/nonmembers", {
            replace: true,
          });
        };

        dispatch(
          updateNonMember({
            memberId: parseInt(id),
            buildingId: parseInt(buildingId),
            firstName,
            lastName,
            email,
            idNumber,
            isActive: isActive === "true",
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    dispatch(getAllBuildings());
    if (id) {
      dispatch(getMemberById({ memberId: Number(id) }));
    }
    return () => {
      dispatch(clearGetMemberById());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (memberById) {
      setBuildingId(memberById?.building?.buildingId?.toString() || "");
      setFirstName(memberById?.member?.firstName || "");
      setLastName(memberById?.member?.lastName || "");
      setEmail(memberById?.member?.email || "");
      setIdNumber(memberById?.member?.nationalId || "");
      setIsActive(memberById?.member?.isActive?.toString() || "true");
    }
  }, [memberById]);

  if (memberByIdLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.mainContainer}>
      <Link
        to="/admin/nonmembers"
        replace
        className={styles.backButtonContainer}
      >
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Non Members
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Edit Non Members</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Building</p>
          <select
            className={styles.input}
            value={buildingId}
            onChange={(e) => setBuildingId(e.target.value)}
          >
            {!buildingId && <option value="">Select Building</option>}
            {buildings?.map((building) => (
              <option key={building.buildingId} value={building.buildingId}>
                {building.buildingName}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.buildingId}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>First Name</p>
          <input
            type="text"
            className={styles.input}
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <p className={styles.error}>{errors.firstName}</p>
        </div>
        <div className={styles.doubleInputContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Last Name</p>
            <input
              type="text"
              className={styles.input}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <p className={styles.error}>{errors.lastName}</p>
          </div>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Email</p>
          <input
            type="text"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <p className={styles.error}>{errors.email}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>National ID</p>
          <input
            type="text"
            className={styles.input}
            value={idNumber}
            onChange={(e) => setIdNumber(e.target.value)}
          />
          <p className={styles.error}>{errors.idNumber}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Status</p>
          <select
            className={styles.input}
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
          >
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
          <p className={styles.error}>{errors.isActive}</p>
        </div>

        {updateNonMemberLoading && <Loading />}

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={updateNonMemberHandler}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditNonMember;
